import Image from 'next/image'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


export default function PrivacyPolicyComponent() {   
    return (
        <article className='sectionOrArticleTB'>
            <div className='text-center'>
                <h1 className='caregoriesTitle'>Privacy Policy</h1>
            </div>
            <article className='sectionOrArticleTB'>
                <div className='imgStripContainer'>
                    <div className='imgStripText'>
                        <Image src='/images/Strip5.gif'
                            alt="Strip"
                            fill
                            sizes="(max-width: 768px) 100vw,
                        (max-width: 1200px) 50vw,
                        33vw"
                        />
                    </div>
                </div>
            </article>
            <article className='sectionOrArticleT mt-5 mt-lg-0 mt-xl-0 mt-xxl-0'>
                <Container>
                    <Row className="justify-content-center">
                        <Col xs={12} sm={11} md={10} lg={9} xl={8}>
                            <p>We believe that the most important advantage of owning physical precious metals and rare coins, medals and banknotes
                                is that transactions can be discreet, private, and secure. We respect the privacy of all of our clients, we do not take any personal information
                                that isn&apos;t necessary to complete a transaction.
                            </p>
                            <p>At FL Gold Coin Exchange the privacy of our clients and other website visitors is of the utmost importance.  All information you
                                provide us when using our website is held in confidence.
                            </p>
                        </Col>
                    </Row>
                </Container>
            </article>

        </article>
    )
}